/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Author } from '../../models/author';

export interface GetAuthor$Params {
  id: string;
}

export function getAuthor(http: HttpClient, rootUrl: string, params: GetAuthor$Params, context?: HttpContext): Observable<StrictHttpResponse<Author>> {
  const rb = new RequestBuilder(rootUrl, getAuthor.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {"style":"simple"});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Author>;
    })
  );
}

getAuthor.PATH = '/v0/authors/{id}';
